import { render, staticRenderFns } from "./CompaniesContactSection.vue?vue&type=template&id=600ca283&scoped=true&"
import script from "./CompaniesContactSection.vue?vue&type=script&lang=js&"
export * from "./CompaniesContactSection.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesContactSection.vue?vue&type=style&index=0&id=600ca283&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600ca283",
  null
  
)

export default component.exports